module.exports = "/_next/static/images/you_coffee-4f3056f578538564b353136665ed78ff.jpg";